import { storageData } from "services/Services"

const CollisionTypeList = () => {
    let options = []
    try {
        const dropdownOptions = JSON.parse(storageData.getItem('DropdownOptions'))
        const collisionTypeOptions = dropdownOptions.rows.filter(row => row.QuestionID === "104")

        if (collisionTypeOptions.length > 0) {
            options = [
                <option key="default" disabled value="">Select from the following...</option>,
                ...collisionTypeOptions.map(answer => (
                    <option key={answer.AnswerID} value={answer.AnswerText}>{answer.AnswerText}</option>
                ))
            ]
        }
    } catch (error) {
        console.error(error)
        options = [<option key="default" value="">Select from the following...</option>]
    }

    return <>{options}</>
}

export default CollisionTypeList